module.exports = {
          srcSet: __webpack_public_path__ + "images/1933-e928ec4bd03941a51029d795a3b21ff0-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1933-83f76c1c81b05a7a4d5cc19b912934de-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1933-e928ec4bd03941a51029d795a3b21ff0-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1933-83f76c1c81b05a7a4d5cc19b912934de-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1933-e928ec4bd03941a51029d795a3b21ff0-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1933-e928ec4bd03941a51029d795a3b21ff0-320.jpg"},
          
          width: 320,
          height: 251
        }